import { createFileRoute } from '@tanstack/react-router'

import { RevenueReportPathParamsSchema } from '@/pages/brevo/revenue/revenue-report-search'

export const Route = createFileRoute('/_layout/brevo/revenue/$id')({
  params: {
    parse: (raw) => RevenueReportPathParamsSchema.parse(raw),
    stringify: ({ id }) => ({ id }),
  },
})
